import axios from 'axios'
import { useState, useEffect } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/modal-tiposDeobservacoes/modalNovaQuestao.css'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    zeraCampos()
    setModal(!modal)
  }
  var user = authService.getCurrentUser()
  let newDate = new Date()

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  const [campos, setCampos] = useState({
    IdObservacaoQuestao: 0,
    IdObservacaoGrupo: sessionStorage.IdObservacaoGrupoEdit,
    IdObservacaoSubGrupo: sessionStorage.IdObservacaoSubGrupo,
    IdObservacaoTipo: sessionStorage.IdObservacaoTipoEdit,
    IdEmpresa: user[0].IdEmpresa,
    oqsNumero: 0,
    oqsDescricao: '',
    oqsStatus: 1,
    oqsObservacoes: '',
    oqsCriadoPor: user[0].pesEmail,
    oqsCriadoEm: newDate,
    oqsAlteradoPor: user[0].pesEmail,
    oqsAlteradoEm: newDate,
    oqsCodigoGUID: uuidv4
  })
  const [observacaoTipo, setObservacaoTipo] = useState([])
    useEffect(() => {
      axios
        .get(
          process.env.REACT_APP_API_URL +
          '/api/v1/observacaotipo/' +
          sessionStorage.IdObservacaoTipoEdit
        )
        .then(response => {
          //console.log('observacaoTipo: ' + response.data)
          setObservacaoTipo(response.data)
        })
        .catch(error => {
          console.error('Erro ao buscar o tipo de observação:', error)
        })
    }, [])
  
    const [grupoQuestao, setGrupoQuestao] = useState([])
    useEffect(() => {
      axios
        .get(
          process.env.REACT_APP_API_URL +
          '/api/v1/observacaogrupo/' +
          sessionStorage.IdObservacaoGrupoEdit
        )
        .then(response => {
          setGrupoQuestao(response.data)
        })
        .catch(error => {
          console.error('Erro ao buscar o grupo de observação:', error)
        })
    }, [])
    
    const [subGrupoQuestao, setSubGrupoQuestao] = useState([])
    useEffect(() => {
      axios
        .get(
          process.env.REACT_APP_API_URL +
          '/api/v1/observacaosubgrupo/' +
          sessionStorage.IdObservacaoSubGrupo
        )
        .then(response => {
          setSubGrupoQuestao(response.data)
        })
        .catch(error => {
          console.error('Erro ao buscar o subgrupo de observação:', error)
        })
    }, [])
    const [contagem, setContagem] = useState(0)
  function handleInputChange(event) {
    if (event.target.name === 'oqsStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
    setContagem(campos.oqsDescricao.length)
  }
  function handleFormSubmit(event) {
    event.preventDefault()
    //console.log(campos)
    axios
      .post(
        process.env.REACT_APP_API_URL + '/api/v1/observacaoquestao',
        campos
      )
      .then(response => {
        if (response.status === 200) {
          alert(response.data.message)
          zeraCampos()
          window.location.reload()
        } else {
          alert(response.data.message)
        }
      })
  }

  function zeraCampos() {
    setCampos({
      IdObservacaoQuestao: 0,
      IdObservacaoGrupo: sessionStorage.IdObservacaoGrupoEdit,
      IdObservacaoSubGrupo: sessionStorage.IdObservacaoSubGrupo,
      IdObservacaoTipo: sessionStorage.IdObservacaoTipoEdit,
      IdEmpresa: user[0].IdEmpresa,
      oqsNumero: 0,
      oqsDescricao: '',
      oqsStatus: 1,
      oqsObservacoes: '',
      oqsCriadoPor: user[0].pesEmail,
      oqsCriadoEm: newDate,
      oqsAlteradoPor: user[0].pesEmail,
      oqsAlteradoEm: newDate,
      oqsCodigoGUID: uuidv4
    })
  }

  //console.log('campos:', campos) // Adicione esta linha para depuração

  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadrao">
        Nova Questão
      </button>

      {modal && (
        <div className="overlay">
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>
                Nova Questão:
                <hr className="hrTitleModal" />
                <span className="subTitleModal">
                  {observacaoTipo[0]?.otpDescricao} / {grupoQuestao[0]?.ogrDescricao} / {subGrupoQuestao[0]?.sbgDescricao ?? 'NI'}
                </span>
              </h1>
              <button className="close-modal" onClick={toggleModal}>
                X
              </button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <div className="linhaTipObs" style={{ width: '100%' }}>
                <tr>
                  <th><label>Ordem</label></th>
                  <th><label>Texto da Questão:</label></th>
                </tr>
                <tr>
                  <td valign='top'>
                    <input
                      type="number"
                      id="oqsNumero"
                      name="oqsNumero"
                      onChange={handleInputChange}
                      defaultValue={campos.oqsNumero}
                    ></input>
                  </td>
                  <td style={{ width: '100%' }}>
                    <textarea
                      type="text"
                      id="oqsDescricao"
                      name="oqsDescricao"
                      rows={3}
                      maxLength="256"
                      onChange={handleInputChange}
                      defaultValue={campos.oqsDescricao}
                    ></textarea>
                    <br />
                    {contagem}/256 caracteres
                  </td>
                </tr>
              </div>

              <label>
                Observações:
              </label>
              <textarea
                type="text"
                id="oqsObservacoes"
                name="oqsObservacoes"
                row="none"
                maxLength="500"
                onChange={handleInputChange}
                defaultValue={campos.oqsObservacoes}
              ></textarea>
              <div className="caixaSalvarPadrao">
                <button type="submit">
                  Salvar Questão
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}
